import Grid from '@mui/material/Grid2';
import { Box, Typography} from '@mui/material';
import MonthlyChart from './MonthlyChart';


const DataVisualization = (): JSX.Element => {

  return (
    <Box marginTop={5} marginBottom={4}>
        <Box marginBottom={3}>
        <Typography
         variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          data-aos={'fade-up'}
          fontWeight={700}
          gutterBottom
          color={'secondary'}
          align={'center'}
        >
          Monthly Fundraising Dashboard
        </Typography>
        </Box>
        <Grid display={'flex'} justifyContent={'center'} container marginTop={2}>
            <MonthlyChart></MonthlyChart>
        </Grid>
    </Box>
    )
}

export default DataVisualization